import { NgModule } from "@angular/core";
import { FileUploadComponent } from "./file-upload/file-upload.component";
import { BreadcrumbComponent } from "./breadcrumb/breadcrumb.component";
import { SharedModule } from "../shared.module";
import { BaseComponent } from "./base/base.component";
import { CardsComponent } from "./cards/cards.component";
import { TableComponent } from "./table/table.component";
import { TableHeaderComponent } from "./table-header/table-header.component";
import { PromptDialogComponent } from "./prompt-dialog/prompt-dialog.component";

@NgModule({
  declarations: [
    FileUploadComponent,
    BreadcrumbComponent,
    BaseComponent,
    CardsComponent,
    TableComponent,
    TableHeaderComponent,
    PromptDialogComponent,
  ],
  imports: [SharedModule],
  exports: [
    FileUploadComponent,
    BreadcrumbComponent,
    CardsComponent,
    TableComponent,
    TableHeaderComponent,
    PromptDialogComponent,
  ],
})
export class ComponentsModule {}
